var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconBatterie(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.33007 18.6666C5.07775 18.6674 4.83038 18.5967 4.61667 18.4625C4.40297 18.3284 4.23171 18.1364 4.1228 17.9088C4.01389 17.6812 3.97179 17.4273 4.0014 17.1768C4.03101 16.9262 4.13111 16.6892 4.29007 16.4932L17.4901 2.89323C17.5891 2.77893 17.724 2.7017 17.8727 2.6742C18.0214 2.6467 18.175 2.67058 18.3084 2.7419C18.4417 2.81322 18.5468 2.92775 18.6065 3.0667C18.6662 3.20565 18.6768 3.36076 18.6367 3.50656L16.0767 11.5332C16.0012 11.7353 15.9759 11.9526 16.0029 12.1666C16.0298 12.3806 16.1083 12.5848 16.2315 12.7618C16.3548 12.9388 16.5191 13.0832 16.7104 13.1828C16.9018 13.2823 17.1144 13.3339 17.3301 13.3332H26.6634C26.9157 13.3324 27.1631 13.4031 27.3768 13.5373C27.5905 13.6714 27.7618 13.8634 27.8707 14.091C27.9796 14.3186 28.0217 14.5724 27.9921 14.823C27.9625 15.0736 27.8624 15.3106 27.7034 15.5066L14.5034 29.1066C14.4044 29.2208 14.2695 29.2981 14.1208 29.3256C13.9721 29.3531 13.8184 29.3292 13.6851 29.2579C13.5518 29.1866 13.4466 29.072 13.387 28.9331C13.3273 28.7941 13.3166 28.639 13.3567 28.4932L15.9167 20.4666C15.9922 20.2645 16.0176 20.0472 15.9906 19.8332C15.9637 19.6192 15.8852 19.415 15.7619 19.238C15.6387 19.061 15.4744 18.9165 15.283 18.817C15.0917 18.7175 14.8791 18.6659 14.6634 18.6666H5.33007Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBatterie);
export default __webpack_public_path__ + "static/media/icon-batterie.0c1e3d4dea5c47b78c2031757959c07d.svg";
export { ForwardRef as ReactComponent };